import {
  Box,
  Divider,
  Flex,
  FormControl,
  FormErrorMessage,
  Grid,
  GridItem,
  RadioGroup,
  Stack,
  Text,
} from "@chakra-ui/react";
import { CustomMultiSelectWField } from "../../../../../components/MultiSelect";
import { useEffect, useState } from "react";
import PromotoriaService from "../../../../../../main/services/PromotoriaService";
import VaraService from "../../../../../../main/services/VaraService";
import DadosGeograficosService from "../../../../../../main/services/DadosGeograficosService";
import { Field } from "formik";
import { renderTooltip } from "../../../../../components/RenderTooltip";
import { RadioButtonField } from "../../../../../components/RadioButtonField";

export const OrgaosAba = ({
  children,
  props,
  isMobile,
  placement,
  token,
  geral,
}) => {
  const [hintPreliminar, setHintPreliminar] = useState(false);
  const [hintRadioOrgao1, setHintRadioOrgao1] = useState(false);
  const [hintRadioOrgao2, setHintRadioOrgao2] = useState(false);
  const [hintRadioOrgao3, setHintRadioOrgao3] = useState(false);
  const [municipiosLogado, setMunicipiosLogado] = useState({
    options: [],
    isLoading: false,
  });

  const [promotorias, setPromotorias] = useState({
    options: [],
    isLoading: false,
  });

  const [varas, setVaras] = useState({
    options: [],
    isLoading: false,
  });

  useEffect(() => {
    setPromotorias((prevState) => ({ ...prevState, isLoading: true }));

    const ids = (props?.values?.idMunicipioOrgao || [])
      ?.flat()
      ?.filter((item) => item?.id)
      ?.map((item) => item.id);

    const hasIds = ids && ids?.length > 0;

    PromotoriaService.pesquisarPromotorias(
      hasIds ? { municipios: ids } : {},
    ).then((res) => {
      const allOption = { id: "", descricao: "Todos" };
      const mappedOptions = res.data.map((item) => ({
        id: item.id,
        descricao: item.nome,
        idMunicipio: item?.municipios[0]?.id,
      }));

      setPromotorias({
        options: hasIds ? mappedOptions : [allOption, ...mappedOptions],
        isLoading: false,
      });
    });
  }, [props?.values?.idMunicipioOrgao]);

  useEffect(() => {
    setVaras((prevState) => ({ ...prevState, isLoading: true }));

    const nomes = (props?.values?.idMunicipioOrgao || [])
      ?.flat()
      ?.filter((item) => item.id != null && item.id !== "")
      ?.map((item) => item.descricao);

    const hasNomes = nomes && nomes?.length > 0;

    VaraService.pesquisarVaras(hasNomes ? { comarcas: nomes } : {}).then(
      (res) => {
        const allOption = { id: "", descricao: "Todos" };
        const mappedOptions = res.data.map((item) => ({
          id: item.id,
          descricao: item.nome,
          idMunicipio: item?.municipios[0]?.id,
        }));

        setVaras({
          options: hasNomes ? mappedOptions : [allOption, ...mappedOptions],
          isLoading: false,
        });
      },
    );
  }, [props?.values?.idMunicipioOrgao]);

  const handleGetMunicipiosLogado = () => {
    setMunicipiosLogado({ ...municipiosLogado, isLoading: true });

    DadosGeograficosService.getMunicipiosLogado(token).then((res) => {
      const allOption = { id: "", descricao: "Todos" };

      const mappedOptions = res.data.map((item) => ({
        id: item.id,
        descricao: item.nome,
      }));

      // if (comarca) {
      //   setComarcasLogado({
      //     options: [allOption, ...mappedOptions],
      //     isLoading: false,
      //   });
      // } else {
      setMunicipiosLogado({
        options: [allOption, ...mappedOptions],
        isLoading: false,
      });
      // }
    });
  };

  return (
    <>
      <Flex mb={4} justifyContent={"space-between"}>
        <Text
          fontWeight={700}
          fontSize="16px"
          lineHeight="21.6px"
          color={"#575553"}
        >
          Órgãos
        </Text>
        {children}
      </Flex>
      <Flex mt={7} mb={2} gap={2}>
        <Text
          fontWeight={700}
          fontSize="14px"
          lineHeight="21.6px"
          color={"#169499"}
        >
          Município
        </Text>
        {renderTooltip(
          isMobile,
          placement,
          "Selecione o Município para habilitar a(s) Promotoria(s) de Justiça e Vara(s) da Infância correspondente(s).",
          hintPreliminar,
          setHintPreliminar,
        )}
      </Flex>
      <Divider orientation="horizontal" borderColor={"#DDEBEA"} />

      <Box mt={7}>
        <CustomMultiSelectWField
          fieldName="idMunicipioOrgao"
          label="Município"
          placeholder="Selecione o Município"
          getOptionLabel={(option) => option.descricao}
          getOptionValue={(option) => option.id}
          isLoading={municipiosLogado.isLoading}
          options={municipiosLogado.options}
          onChange={(value) => {
            props.setFieldValue("idMunicipioOrgao", value);
            props.setFieldValue("idPromotoriaOrgaos", "");
            props.setFieldValue("idVaraOrgaos", "");
          }}
          values={props?.values?.idMunicipioOrgao[0] || ""}
          onFocus={() => handleGetMunicipiosLogado()}
          visible
          todos
        />
      </Box>

      <Text
        fontWeight={700}
        fontSize="14px"
        lineHeight="21.6px"
        color={"#169499"}
        mt={7}
        mb={2}
      >
        Promotoria de Justiça
      </Text>
      <Divider orientation="horizontal" borderColor={"#DDEBEA"} />

      <Box mt={7}>
        <CustomMultiSelectWField
          fieldName="idPromotoriaOrgaos"
          label="Promotoria de Justiça"
          placeholder="Selecione a Promotoria de Justiça"
          getOptionLabel={(option) => option.descricao}
          getOptionValue={(option) => option.id}
          isLoading={promotorias.isLoading}
          options={promotorias.options}
          onChange={(value) => {
            props.setFieldValue("idPromotoriaOrgaos", value);
          }}
          values={props?.values?.idPromotoriaOrgaos[0] || ""}
          visible
          todos
        />
      </Box>

      <Text
        fontWeight={700}
        fontSize="14px"
        lineHeight="21.6px"
        color={"#169499"}
        mt={7}
        mb={2}
      >
        Vara da Infância
      </Text>
      <Divider orientation="horizontal" borderColor={"#DDEBEA"} />

      <Box mt={7}>
        <CustomMultiSelectWField
          fieldName="idVaraOrgaos"
          label="Vara da Infância"
          placeholder="Selecione a Vara da Infância"
          getOptionLabel={(option) => option.descricao}
          getOptionValue={(option) => option.id}
          isLoading={varas.isLoading}
          options={varas.options}
          onChange={(value) => {
            props.setFieldValue("idVaraOrgaos", value);
          }}
          values={props?.values?.idVaraOrgaos[0] || ""}
          visible
          todos
          limitado={true}
        />
      </Box>

      {geral && (
        <Box
          mt={8}
          border={"solid 1px #007A7F66"}
          rounded={"lg"}
          px={4}
          py={"20px"}
        >
          <Text
            fontWeight={700}
            fontSize="14px"
            lineHeight="21.6px"
            color={"#169499"}
            mb={2}
          >
            Critério de Atribuição/Competência
          </Text>
          <Grid
            templateColumns="repeat(15, 1fr)"
            gap="15px"
            mt="15px"
            w="100%"
            alignItems={"center"}
          >
            <GridItem colSpan={{ base: 15 }}>
              <Field name="radioCriterioAtribuicaoCompetencia">
                {({ field, form }) => (
                  <FormControl
                    isInvalid={
                      form.errors.radioCriterioAtribuicaoCompetencia &&
                      form.touched.radioCriterioAtribuicaoCompetencia
                    }
                    id="criterioAtribuicaoCompetencia"
                    width="100%"
                  >
                    <RadioGroup
                      value={field.value}
                      onChange={(value) =>
                        props.setFieldValue(
                          "radioCriterioAtribuicaoCompetencia",
                          value,
                        )
                      }
                    >
                      <Stack direction="column" gap={4}>
                        <Flex gap={1}>
                          <RadioButtonField
                            id="radio-criterioAtribuicaoCompetencia-s"
                            fieldName="radioCriterioAtribuicaoCompetencia"
                            value="C"
                            label="Órgão que Consta na Ficha Criança ou Adolescente"
                          />
                          {renderTooltip(
                            isMobile,
                            placement,
                            "Será considerada o Órgão que consta na ficha da Criança ou Adolescente, ainda que na ficha do Serviço de Acolhimento conste outro Órgão.",
                            hintRadioOrgao1,
                            setHintRadioOrgao1,
                          )}
                        </Flex>
                        <Flex gap={1}>
                          <RadioButtonField
                            id="radio-criterioAtribuicaoCompetencia-n"
                            fieldName="radioCriterioAtribuicaoCompetencia"
                            value="S"
                            label="Órgão que Consta na Ficha do Serviço de Acolhimento"
                          />
                          {renderTooltip(
                            isMobile,
                            placement,
                            "Será considerada o Órgão que consta na ficha do Serviço de Acolhimento, ainda que na ficha da Criança ou Adolescente conste outro Órgão.",
                            hintRadioOrgao2,
                            setHintRadioOrgao2,
                          )}
                        </Flex>
                        <Flex gap={1}>
                          <RadioButtonField
                            id="radio-criterioAtribuicaoCompetencia-si"
                            fieldName="radioCriterioAtribuicaoCompetencia"
                            value="CS"
                            label="Mesmo Órgão na Ficha da Criança ou Adolescente e Ficha do Serviço de Acolhimento"
                          />
                          {renderTooltip(
                            isMobile,
                            placement,
                            "Tanto a ficha da Criança ou Adolescente quanto a ficha do Serviço de Acolhimento terão o mesmo Órgão.",
                            hintRadioOrgao3,
                            setHintRadioOrgao3,
                          )}
                        </Flex>
                      </Stack>
                    </RadioGroup>
                    <FormErrorMessage mt="-1" mr="-16">
                      {form.errors.radioCriterioAtribuicaoCompetencia}
                    </FormErrorMessage>
                  </FormControl>
                )}
              </Field>
            </GridItem>
          </Grid>
        </Box>
      )}
    </>
  );
};
